//Models
import ListViewModel from './model.js';
import AppModel from '../App/model.js';
import FiltersModel from '../_filters/model.js';

//get the ads with applied filters
const init = ListViewModel.init;
// show alert message
const showAlert = AppModel.showAlert;
// reset the first selected state of the real estate type filter
const resetStateRealEstateTypeFilter = FiltersModel.resetStateRealEstateTypeFilter;

$(document).ready(function(){
    //load the init ads on page load
    init();

    $('body').on('click', function (e) {
        const $target = $(e.target);

        // Hide the contact owner modal
        if($target.is('#contact-owner-modal')){
            $('#contact-owner-form').find('input[name="property_id"]').val('');
            $target.removeClass('grid place-items-center')
            .addClass('hidden');
        }
    });

    $('#grid-view-btn').on('click', function () {
        const $btn = $(this);
        const $listViewBtn = $('#list-view-btn');

        if($btn.hasClass('active-btn')) return;

        $btn.addClass('bg-white active-btn');
        $btn.find('svg rect').attr('fill', '#3485FF');
        $listViewBtn.removeClass('bg-white active-btn');
        $listViewBtn.find('svg rect').attr('fill', '#1F3A43');

        $('#realestate-container .grid-view').removeClass('hidden').addClass('grid');
        $('#realestate-container .list-view').addClass('hidden');
    });

    $('#list-view-btn').on('click', function () {
        const $btn = $(this);
        const $gridViewBtn = $('#grid-view-btn');

        if($btn.hasClass('active-btn')) return;

        $btn.addClass('bg-white active-btn');
        $btn.find('svg rect').attr('fill', '#3485FF');
        $gridViewBtn.removeClass('bg-white active-btn');
        $gridViewBtn.find('svg rect').attr('fill', '#1F3A43');

        $('#realestate-container .grid-view').removeClass('grid').addClass('hidden');
        $('#realestate-container .list-view').removeClass('hidden');
    });

    // toggle favorite button in listing page
    $('#realestate-container').on('click', '.fav-btn', function (e) {
        e.stopPropagation();
        e.preventDefault();
        const $btn = $(this);
        // get the favorite button with matched id to update the icon in both grid and list view
        const $favBtn = $('.fav-btn').filter(function () {
            return $(this).attr('id') === $btn.attr('id');
        });
        const $icon = $favBtn.find('> i');

        if($icon.length === 0) return;

        $.ajax({
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            url: $icon.data('route'),
            type: 'POST',
            dataType: 'json',
            context: this,
            success: function (response) {
                $icon.toggleClass('fa-solid fa-regular text-red-600 text-white')
                    .data('route', response.data.fav_url);

                showAlert(response.message);
            },
            error: function (error) {                
                if(error.responseJSON && error.responseJSON.data){
                    window.location.href = error.responseJSON.data.redirect;
                }
            }
        });
    });

    //update the sort div with the selected option and update the list
    document.querySelectorAll('[name="sort-selection"]').forEach((input) => {
        input.addEventListener('change', function () {
            const $form = $('#search-page-filters');
            const $value = $(this).val();
            const $text = $(this).parent().find('label').text();
    
            if($form.hasClass('listing-view')){
                $('.sort-container div span span').text($text);
                $form.find('#sort_by').val($value);

                // get new ads based on chosen sort option
                ListViewModel.isInit = true;
                ListViewModel.removeObserver();
                init();
            }
            $(this).closest('[data-dropdown-toggle]').removeClass('opened');
        });
    });

    //delete filter bubble and update the list
    $('#listing-body').on('click', '.filter-bubble',function () {
        const $btn = $(this);

        if($btn.data('ref') === 'more-filter-dropdown'){
            const filterType = $btn.data('ref');
            const $filterDropdown = $(`#${filterType}`);
            const $inputs = $filterDropdown.find(`input[name="${$btn.data('name')}"]`);

            if($inputs.attr('type') === 'checkbox' || $inputs.attr('type') === 'radio'){
                if($inputs.attr('name') === 'chambers_number[]' || 
                $inputs.attr('name') === 'is_first_owner' || 
                $inputs.attr('name') === 'energy_class[]' ){
                    $inputs.prop('checked', false);
                }else{
                    $inputs.filter(function(){
                        return $(this).val() === $btn.data('value');
                    }).prop('checked', false);
                }
            }else if ($inputs.attr('name') === 'keywords[]'){
                //remove the keyword hidden input from the list
                $inputs.filter(function(){
                    return $(this).val() === $btn.data('value');
                }).remove();

                //remove the keyword bubble from the list
                $('.keyword').filter(function(){
                    return $(this).text().trim().slice(0,-1) === $btn.data('value');
                }).remove();

            }else{
                $inputs.val('');
            }

            $filterDropdown.find('button[aria-label=Done]').trigger('click');
        }else{
            const filterType = $btn.data('ref');
            const $filterDropdown = $(`#${filterType}`);

            $filterDropdown.find('button[aria-label=Reset]').trigger('click');
        }
    });

    //reset all filters and update the list
    $('#listing-body').on('click', '.reset-bubble',function () {
        const $filtersDropdown = $('[data-dropdown-toggle]');
        const $form = $('#search-page-filters');
        const $span = $filtersDropdown.find('span span');

        //reset radio and checkbox inputs
        $form.find('input[type="checkbox"] , input[type="radio"]')
        .filter(function(){
            return $(this).attr('name') !== 'ad_type';
        })
        .prop({
            checked: false,
            disabled: false
        });

        //reset bedroom inputs
        $('input[name="chambers_number[]"]').next()
        .removeClass('border-gray-200 text-gray-200 cursor-not-allowed')
        .addClass('text-gray-800 border-gray-400 cursor-pointer');

        //remove hidden inputs with associated bubbles
        $form.find('input[type="hidden"]').filter(function(){
            return $(this).attr('name') !== 'sort_by';
        }).remove();

        $('.keyword').remove();
        $('.counter-bubble').remove();
        $('.location-bubble').remove();

        //reset text inputs
        $form.find('input[type="text"] , input[type="number"]')
        .val('')
        .prop('disabled', false);

        //reset the span text with the default text from aria label
        $span.each(function(){
            $(this).text($(this).attr('aria-label'));
        });
 
        //reset style filter span and text 
        $filtersDropdown
        .filter(function(){
            return $(this).data('dropdown-toggle') !== 'ad-types-dropdown' &&
            $(this).data('dropdown-toggle') !== 'sort-option';
        
        })
        .find('> span')
        .removeClass('bg-light-blue text-blue-brand')
        .addClass('bg-slate-100');

        $filtersDropdown
        .filter(function(){
            return $(this).data('dropdown-toggle') !== 'ad-types-dropdown' &&
            $(this).data('dropdown-toggle') !== 'sort-option';
        })
        .find('.search-popup').each(function(){
            $(this).data('applied', false);
        });

        //reset the real estate types filter based on the selected types
        $form.find('input[name="realestate_type[]"]')
            .removeClass('first-selected');

        // reset the [applied] state of the filters in more filters dropdown
        $('#more-filter-dropdown .filter-option').data('applied', false);
        const $appliedFiltersCount = $('#applied-filters-count');

        if($appliedFiltersCount.hasClass('flex')){
            $appliedFiltersCount.toggleClass('hidden flex justify-center items-center');
        }
        $appliedFiltersCount.find('> span').text(0);
        
        resetStateRealEstateTypeFilter();

        // get the ads with the reset filters
        ListViewModel.isInit = true;
        ListViewModel.removeObserver();
        init();
    });

    //update the ads listing based on selected suggestion
    $('#listing-body').on('click', '.suggestion',function(){
        const $link = $(this);
        const $form = $('#search-page-filters');
        const $filtersDropdowns = $('[data-dropdown-toggle]');
        const $span = $filtersDropdowns
            .filter(function(){
                return $(this).data('dropdown-toggle') !== 'ad-types-dropdown' &&
                $(this).data('dropdown-toggle') !== 'sort-option' &&
                $(this).data('dropdown-toggle') !== 'types-dropdown';
            })
            .find('span span');
        const $roomsInput = $form.find('input[name="pieces_number[]"]');

        //reset inputs of type checkbox and radio in more filters dropdown
        $form.find('#more-filter-dropdown input[type="checkbox"] ,#more-filter-dropdown input[type="radio"]')
        .prop({
            checked: false,
            disabled: false
        });

        //reset text and number inputs
        $form.find('input[type="text"] , input[type="number"]')
        .val('')
        .prop('disabled', false);
        
        //remove keywords inputs with associated bubbles
        $form.find('input[name="keywords[]').remove();
        $('.keyword').remove();

        //reset bedroom filter
        $('input[name="chambers_number[]"]').next()
        .removeClass('border-gray-200 text-gray-200 cursor-not-allowed')
        .addClass('text-gray-800 border-gray-400 cursor-pointer');

        //reset the span text with the default text from aria label
        $span.each(function(){
            $(this).text($(this).attr('aria-label'));
        });

        //reset style filter span and text 
        $filtersDropdowns
        .filter(function(){
            return $(this).data('dropdown-toggle') !== 'ad-types-dropdown' &&
            $(this).data('dropdown-toggle') !== 'sort-option' &&
            $(this).data('dropdown-toggle') !== 'types-dropdown';
        })
        .find('> span')
        .removeClass('bg-light-blue text-blue-brand')
        .addClass('bg-slate-100');

        $filtersDropdowns
        .filter(function(){
            return $(this).data('dropdown-toggle') !== 'ad-types-dropdown' &&
            $(this).data('dropdown-toggle') !== 'sort-option' &&
            $(this).data('dropdown-toggle') !== 'types-dropdown';
        })
        .find('.search-popup').each(function(){
            $(this).data('applied', false);
        });
    
        //reset rooms filter and update to the selected room
        $roomsInput.prop('checked', false);
        $roomsInput.filter(function(){
            return $(this).val() === $link.data('rooms');
        }).trigger('click');

        $('#pieces-dropdown').find('button[aria-label=Done]').trigger('click');

    });

    // handling the contact owner modal
    $('#close-contact-owner-modal').on('click', function () {
        $('#contact-owner-form').find('input[name="property_id"]').val('');
        $('#contact-owner-modal').removeClass('grid place-items-center')
        .addClass('hidden');
    });

    $(document).on('click', '.email-btn' ,function (event) {
        //prevent redirect to the property details page
        event.preventDefault();
        const $btn = $(this);
        const $card = $btn.closest('.card-link');
        const realEstateId = $card.find('.fav-btn').attr('id');
        const $form = $('#contact-owner-form');
        const $modal = $('#contact-owner-modal');
        const $formTitle = $modal.find('h3');

        if($card.data('poster-type') == 1){
            $formTitle.text('Ce logement vous plaît ? Contactez le propriétaire');
        }else{
            $formTitle.text("Ce logement vous plaît ? Contactez le l'agence");
        }

        $form.find('input[name="property_id"]').val(realEstateId);
        $form.find('#message').val('');
        $('#contact-owner-modal').addClass('grid place-items-center')
        .removeClass('hidden');
    });
    
    $('#contact-owner-form').on('submit', function (e) {
        e.preventDefault();

        const $form = $(this);
        const url = $form.attr('action');
        const payload = $form.serialize();
        const $submitButton = $form.find('button[type="submit"]');
        const submitButtonText = $submitButton.data('sending-text') ?? 'Soumettre ...';

        // clear all validation errors
        $form.find('.error').empty();

        $submitButton.text(submitButtonText);
        $submitButton.prop('disabled', true);

        $.ajax({
            headers: { 'X-CSRF-TOKEN': $form.find('input[name="_token"]').val() },
            url: url,
            type: 'POST',
            data: payload,
            dataType: 'json',
            context: this,
            success: function (response) {
                if(response.status === 200){
                    showAlert(response.message);
                    $('#contact-owner-modal').removeClass('grid place-items-center')
                    .addClass('hidden');
                }else{
                    showAlert(response.message, 'error');
                }
            },
            error: function(error) {
                const errors = error.responseJSON.errors;

                // loop through validation errors
                for (const key in errors) {
                    if (errors.hasOwnProperty(key)) {
                        const errorMessages = errors[key];
                        const $errorsList = $form.find(`#${key}_error`);
                        $errorsList.empty();
                        errorMessages.forEach(message => {
                            $errorsList.append(`<li>${message}</li>`);
                        });
                    }
                }
            },
            complete: function(){
                $submitButton.text($submitButton.attr('aria-label'));
                $submitButton.prop('disabled', false);
            }
        });
    });

    // Show phone number and copy it to clipboard
    $(document).on('click', '.call-btn' ,function(event){
        //prevent redirect to the property details page
        event.preventDefault();
        const $btn = $(this);
        const getOwnerPhoneUrl = $btn.data('route');
        const showPhoneNumber = $btn.data('show-phone') ;
        const $copied = $btn.find('.copied');
        const $callMe = $btn.find('.call-me');

        // show phone number
        if(showPhoneNumber == '0'){
            $.ajax({
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                url: getOwnerPhoneUrl,
                type: 'GET',
                dataType: 'json',
                context: this,
                success: function (response) {
                    if(response.status == 200){
                        $callMe.text(response.phone);
                        $btn.data('phone', response.phone);
                        $btn.data('show-phone', '1');
                    }else{
                        showAlert('retrieving phone number failed', 'error');
                    }
                },
                error: function(error){
                    showAlert('retrieving phone number failed', 'error');
                    console.error(error.message);
                }
            });
        }else{
            // Create a temporary input element to copy the text
            const tempInput = $('<input>');
            $('body').append(tempInput);
            tempInput.val($btn.data('phone')).select();
            document.execCommand('copy');
            tempInput.remove();
            $callMe.hide();
            $copied.fadeIn(
                function(){
                    setTimeout(function(){
                        $copied.fadeOut(function() {
                            $callMe.show();
                        });
                    }, 1000);
                }
            );
        }
    });
    
});